import React, { FC, useState, MouseEvent, useEffect } from "react";
import { AdminLayout } from "../../../../components/layouts/admin-layout/admin-layout";
import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CustomButton } from "../../../../components";
import AddIcon from "@mui/icons-material/Add";
import { Colors } from "../../../../configs";
import { styled } from "@mui/material/styles";
import {
  ContentCopy,
  ContentCut,
  ContentPaste,
  EditOutlined,
  PanoramaFishEyeOutlined,
} from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Link, useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Cloud from "@mui/icons-material/Cloud";
import StorefrontIcon from "@mui/icons-material/Storefront";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import StoreIcon from "@mui/icons-material/Store";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks";
import { useAppSelector } from "../../../../hooks";
import { getMerchantStores } from "../../../../redux/actions/merchantAction";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { EditPickupTimeDrawer } from "../../../../components/admin/edit-pickup-time-drawer/EditPickupTimeDrawer";
import { useSnackbarContext } from "../../../../providers/SnackbarProvider";
import { CustomerSettingsDrawer } from "../../../../components/admin/customer-settings-drawer/CustomerSettingsDrawer";

interface IStoresPageProps { }

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StoresPage: FC<IStoresPageProps> = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openContextMenu = Boolean(anchorEl);
  const [contextMenuStore, setContextMenuStore] = useState<null | number>(null);
  const [openTimeEditDrawer, setOpenTimeEditDrawer] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useAppDispatch();
  const merchantStoresResponse = useAppSelector(
    (state) => state.merchant.merchantStoresResponse
  );
  const merchantStoresResponseLoading = useAppSelector(
    (state) => state.merchant.merchantStoresLoading
  );
  const [searchParams] = useSearchParams();
  const snackbar = useSnackbarContext();
  const merchantId = searchParams.get("merchantId")
    ? Number(searchParams.get("merchantId"))
    : null;
  const OpenStoreTimeConfigDrawer =
    contextMenuStore !== null && merchantId !== null && openTimeEditDrawer;
  // const OpenStoreConfigurePinTagDrawer =
  //   contextMenuStore !== null &&
  //   merchantId !== null &&
  //   openConfigurePinTagDrawer;

  console.log("Open Drawer", OpenStoreTimeConfigDrawer);

  !merchantId &&
    snackbar.showSnackbar(
      "Merchant id query parameter is not detected",
      "error"
    );

  const merchantWhiteLabel = params["merchantWhiteLabel"];

  useEffect(() => {
    if (merchantWhiteLabel === "undefined" || !merchantWhiteLabel) {
      snackbar.showSnackbar("Merchant is not detected", "error");
    } else {
      dispatch(getMerchantStores(merchantWhiteLabel));
    }
  }, [merchantWhiteLabel]);

  const handleClick = (
    event: MouseEvent<HTMLButtonElement>,
    merchant: number
  ) => {
    setAnchorEl(event.currentTarget);
    setContextMenuStore(merchant);
  };
  const handleClose = () => {
    setAnchorEl(null);
    // setContextMenuStore(null);
  };
  const handleOnToggleTimeEditDrawer = () => {
    setOpenTimeEditDrawer((state) => !state);
    // setContextMenuStore(null);
    handleClose();
  };

  const [openCustomerSettingsDrawer, setOpenCustomerSettingsDrawer] = useState(false);
  const handleOnToggleCustomerSettingsDrawer = () => {
    setOpenCustomerSettingsDrawer((state) => !state);
    handleClose();
  };

  const openManageCashiers = () => {
    navigate(`/admin/config/merchants/1/stores/${contextMenuStore}/cashiers`);
    handleClose();
  };

  return (
    <AdminLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "3rem",
          height: "57.5rem",
          marginTop: "4.35714286rem",
          paddingInline: "5rem",
          width: "100%",
          maxHeight: "57.5rem",
        }}
      >
        {OpenStoreTimeConfigDrawer && (
          <EditPickupTimeDrawer
            open={OpenStoreTimeConfigDrawer}
            toggleDrawer={handleOnToggleTimeEditDrawer}
            storeId={contextMenuStore}
            merchantId={merchantId}
          />
        )}
        <CustomerSettingsDrawer
          open={openCustomerSettingsDrawer}
          toggleDrawer={handleOnToggleCustomerSettingsDrawer}
        />
        {/* {OpenStoreConfigurePinTagDrawer && (
          <ConfigurePinTagDrawer
            open={OpenStoreConfigurePinTagDrawer}
            toggleDrawer={handleOnToggleConfigurePinTagDrawer}
            storeId={contextMenuStore}
          />
        )} */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" sx={{ color: Colors.TEXT_GRAY_DARK }}>
            Stores
          </Typography>
          <Link to="/admin/config/merchants/1/stores/create">
            <CustomButton
              sx={{
                width: "11.0714286rem",
                height: "3.07142857rem",
              }}
            >
              Add New
            </CustomButton>
          </Link>
        </Box>

        <Box
          sx={{
            maxHeight: "51.42857143rem",
            width: "100%",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "0.5rem",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <Table sx={{ width: "100%" }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Store Name</StyledTableCell>
                <StyledTableCell>address</StyledTableCell>
                <StyledTableCell>Email</StyledTableCell>
                <StyledTableCell>Phone</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {merchantStoresResponse?.body?.map((row) => (
                <StyledTableRow key={row.storeId}>
                  <StyledTableCell>{row.storeName}</StyledTableCell>
                  <StyledTableCell>N/A</StyledTableCell>
                  <StyledTableCell>N/A</StyledTableCell>
                  <StyledTableCell>N/A</StyledTableCell>
                  <StyledTableCell>
                    <IconButton onClick={(e) => handleClick(e, row.storeId)}>
                      <MoreHorizIcon
                        sx={{ fontSize: "2rem" }}
                        color="primary"
                      />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
              {(merchantStoresResponse?.body ?? []).length === 0 &&
                !merchantStoresResponseLoading && (
                  <StyledTableRow>
                    <StyledTableCell colSpan={5}>
                      No Stores found
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              {merchantStoresResponseLoading && (
                <StyledTableRow>
                  <StyledTableCell colSpan={5} sx={{ textAlign: "center" }}>
                    <CircularProgress />
                  </StyledTableCell>
                </StyledTableRow>
              )}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openContextMenu}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={openManageCashiers}>
                  <ListItemIcon>
                    <PointOfSaleIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Manage Cashier Points</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <EditIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Edit Store</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleOnToggleTimeEditDrawer}>
                  <ListItemIcon>
                    <AccessAlarmIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Edit Pickup Time</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleOnToggleCustomerSettingsDrawer}>
                  <ListItemIcon>
                    <AccessAlarmIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Customer Settings</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <DeleteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Delete Store</ListItemText>
                </MenuItem>
              </Menu>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </AdminLayout>
  );
};

export default StoresPage;
